import React, { useEffect } from 'react'

interface NotificationProps {
  message: string
  type: 'success' | 'error'
  onClose: () => void
  duration?: number // milliseconds, default 4000
}

export const Notification: React.FC<NotificationProps> = ({
  message,
  type,
  onClose,
  duration = 4000
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, duration)
    return () => clearTimeout(timer)
  }, [duration, onClose])

  const isSuccess = type === 'success'

  return (
    <div
      className={`fixed top-6 right-6 z-[2000] rounded-lg px-5 py-4 shadow-lg flex items-center gap-3 min-w-[320px] max-w-[500px] border ${
        isSuccess ? 'bg-[#f6ffed] border-[#b7eb8f]' : 'bg-[#fff2f0] border-[#ffccc7]'
      }`}
    >
      {isSuccess ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="flex-none">
          <circle cx="12" cy="12" r="10" fill="#52c41a"/>
          <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ) : (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="flex-none">
          <circle cx="12" cy="12" r="10" fill="#ff4d4f"/>
          <path d="M15 9l-6 6M9 9l6 6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )}
      <span className={`text-sm font-medium flex-1 ${isSuccess ? 'text-[#52c41a]' : 'text-[#ff4d4f]'}`}>
        {message}
      </span>
      <button
        onClick={onClose}
        className={`bg-transparent border-0 text-lg cursor-pointer p-0 leading-none opacity-60 ${
          isSuccess ? 'text-[#52c41a]' : 'text-[#ff4d4f]'
        }`}
      >
        ×
      </button>
    </div>
  )
}
